const Const = {
    ERROR_PAGE_SERVER_ERROR: 'ERROR_PAGE_SERVER_ERROR',
    ERROR_DIALOG_LOCALIZATION_ERROR: 'ERROR_DIALOG_LOCALIZATION_ERROR',
    ERROR_DIALOG_RETURNS_DATA_ERROR: 'ERROR_DIALOG_RETURNS_DATA_ERROR',
    ERROR_DIALOG_INBOUND_DATA_ERROR: 'ERROR_DIALOG_INBOUND_DATA_ERROR',
    ERROR_DIALOG_CLOSE: 'ERROR_DIALOG_CLOSE',
};

export default Const;